import {CPaymentLinkStatuses} from '@/app/main/paymentLink/models/constants/paymentLink.constants';

import {
  FeeModel,
  ICheckoutResultResponseModel,
  IFeesResponse,
  IGetCheckoutResultResponse,
  IPaymentLinkResponse,
  PaymentLinkModel,
} from './entities';
import {PaymentLinkStatusType} from './types';

const getPaymentLinkStatus = (
  response: Pick<IPaymentLinkResponse, 'single_payment' | 'link_consumed'>,
): PaymentLinkStatusType => {
  return response?.single_payment && response?.link_consumed
    ? CPaymentLinkStatuses.USED
    : CPaymentLinkStatuses.VALID;
};
export const getPaymentLinkMapper = (
  response: IPaymentLinkResponse,
): PaymentLinkModel => {
  return {
    link_consumed: response?.link_consumed,
    receiver_user: response?.receiver_user,
    single_payment: response?.single_payment,
    amount: response?.amount,
    gif: response?.gif,
    note: response?.note,
    status: getPaymentLinkStatus(response),
  };
};

export const getFeesMapper = (response: IFeesResponse): FeeModel => {
  return {
    fees: response?.fees,
  };
};

export const getCheckoutResultMapper = (
  response: IGetCheckoutResultResponse,
): ICheckoutResultResponseModel => {
  return {
    amount: response.amount,
    amount_without_fee: response.amount_without_fee,
    created_at: response.created_at,
    status: response.status,
    type: response.type,
    receiver_user: response.receiver_user,
  };
};
